export default __webpack_public_path__ + "images/parttime-icon-f86cb2.svg";